import React, { useState, useEffect, useRef } from "react";
import "./Testimoniais.css";

import "react-multi-carousel/lib/styles.css";
import ReadyImg from "../assets/images/ready-img.png";
import Graduate01 from "../assets/images/graduate01.png";
import Graduate02 from "../assets/images/graduate02.png";
import Graduate03 from "../assets/images/graduate03.png";

const Testimoniais = () => {
  const [counts, setCounts] = useState({
    workshops: 0,
    collegeReach: 0,
    mentees: 0,
    menteesEnrolled: 0
  });
  const [hasAnimated, setHasAnimated] = useState(false);
  const statsRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !hasAnimated) {
          setHasAnimated(true);
          animateCounters();
        }
      },
      { threshold: 0.5 }
    );

    if (statsRef.current) {
      observer.observe(statsRef.current);
    }

    return () => {
      if (statsRef.current) {
        observer.unobserve(statsRef.current);
      }
    };
  }, [hasAnimated]);

  const animateCounters = () => {
    const duration = 2000; // 2 seconds
    const targets = {
      workshops: 60,
      collegeReach: 1950,
      mentees: 60000,
      menteesEnrolled: 35
    };

    const increment = (target, key) => {
      const steps = 60;
      const stepValue = target / steps;
      let current = 0;
      
      const timer = setInterval(() => {
        current += stepValue;
        if (current >= target) {
          setCounts(prev => ({ ...prev, [key]: target }));
          clearInterval(timer);
        } else {
          setCounts(prev => ({ ...prev, [key]: Math.floor(current) }));
        }
      }, duration / steps);
    };

    Object.keys(targets).forEach(key => increment(targets[key], key));
  };

  return (
    <div className="testimonials__section">
      <div className="testimonials-bar">
        <div className="dive-section">
          <div className="dive-title-bar">
            <div className="dive-title">Ready to Dive In? <span>Here's who can apply!</span></div>
            <p>Whether you're a passionate beginner or a seasoned pro, if you're eager to grow, you might be exactly who we need.</p> 
          </div>
          <div className="ready-content">
             <div className="ready-img"><img src={ReadyImg} className="readyimg" /></div>
             <div className="ready-text-bar">
              <div className="ready-text">
                <div className="graduate-bar">
                 <div className="graduate-icon"><img src={Graduate01} className="graduate-img" /></div> 
                 <div className="graduate-text">
                  <span>Graduates from Any Field</span>
                  <p>Ideal for graduates from any background with an interest in tech. No prior technical experience is required.</p>
                  </div> 
                </div>
                <div className="graduate-bar">
                 <div className="graduate-icon"><img src={Graduate02} className="graduate-img" /></div> 
                 <div className="graduate-text">
                  <span>Curious Beginners & Hobbyists</span>
                  <p>Perfect for beginners exploring robotics as a passion. This program guides your learning step-by-step.</p>
                  </div> 
                </div>
                <div className="graduate-bar">
                 <div className="graduate-icon"><img src={Graduate03} className="graduate-img" /></div> 
                 <div className="graduate-text">
                  <span>STEM Students</span>
                  <p>Great for STEM students who want hands-on experience and a deeper understanding of robotics and AI.</p>
                  </div> 
                </div>                                
              </div>
            </div>
          </div> 
        </div>
      </div>

      {/* Statistics Section */}
      <div className="stats-section" ref={statsRef}>
        <div className="stats-container">
          <div className="stat-item">
            <div className="stat-number">{counts.workshops}+</div>
            <div className="stat-label">Workshops/Industrial<br/>Trainings</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">{counts.collegeReach.toLocaleString()}+</div>
            <div className="stat-label">College Reach</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">{counts.mentees.toLocaleString()}+</div>
            <div className="stat-label">Mentees Enrolled</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">{counts.menteesEnrolled}+</div>
            <div className="stat-label">Mentors Pool</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimoniais;